import ModalCore from '@studiometa/js-toolkit/components/Modal';

/**
 * Modal class
 */
export default class Modal extends ModalCore {
  /**
   * Config
   */
  get config() {
    return {
      ...super.config,
      move: true,
      autoOpen: 300,
      styles: {
        modal: {
          closed: 'hidden',
        },
      },
    };
  }

  /**
   * Mounted
   */
  mounted() {
    super.mounted();

    if (this.$options.autoOpen) {
      clearTimeout(this.timer);
      this.timer = setTimeout(this.open, this.$options.autoOpen);
    }
  }

  /**
   * Destroyed
   */
  destroyed() {
    super.destroyed();

    clearTimeout(this.timer);
  }
}
